<template>
  <td class="cell"
      data-int="cart-cell-qty">
    <input v-if="canEdit"
           v-model="quantity"
           autocomplete="off"
           class="input"
           data-int="cart-cell-qty-input"
           max="999999999"
           min="0"
           type="number"
           :disabled="isUpdating"
           :data-key="uuid"
           :key="uuid">
    <div v-else
         class="has-text-centered">
      {{ quantity }}
    </div>
  </td>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
export default {
  name: 'CartCellQty',
  props: {
    item: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      draftQty: this.item?.qty
    }
  },
  watch: {
    'item.qty' (newQty) {
      // Sync draft back to store value when the API response updates the item.
      // Only overwrite if the user isn't currently typing a different value.
      if (String(this.draftQty) !== String(newQty)) {
        this.draftQty = newQty
      }
    }
  },
  computed: {
    ...mapGetters('cart', ['isItemUpdating']),
    isUpdating () {
      return this.isItemUpdating(this.item)
    },
    quantity: {
      get () {
        return this.draftQty
      },
      set (value) {
        this.draftQty = value
        this.debouncedEmit(value)
      }
    }
  },
  created () {
    // Per-instance debounce so rapid edits across rows do not collapse into
    // a single update (a shared debounce would drop all but the last call).
    this.debouncedEmit = debounce((value) => {
      if (value !== '') {
        this.$emit('update', {
          item: this.item,
          qty: value
        })
      }
    }, 1000)
  },
  beforeUnmount () {
    this.debouncedEmit?.cancel?.()
  },
  setup () {
    return {
      uuid: uuidv4()
    }
  }
}
</script>

<style scoped>
.cell, .input {
  width: 5rem;
}
</style>
